import React from "react";
import { Shield, Zap, Award } from "lucide-react";
import "./WhyChooseUs.css";

export const WhyChooseUs = () => {
  const reasons = [
    {
      icon: Shield,
      title: "Quality Assurance",
      description: "Every product undergoes rigorous testing to ensure premium quality and durability"
    },
    {
      icon: Zap,
      title: "Cutting-Edge Technology",
      description: "Stay ahead with the latest innovations and breakthrough features in electronics"
    },
    {
      icon: Award,
      title: "Industry Leading Warranty",
      description: "Comprehensive warranty coverage and dedicated customer support for peace of mind"
    }
  ];

  return (
    <section id="why-choose-us" className="why-section">
      <div className="why-container">
        <div className="section-header">
          <h2 className="section-title">Why Choose Singularity</h2>
          <p className="section-description">
            We're committed to delivering excellence in every aspect of your experience
          </p>
        </div>

        <div className="reasons-grid">
          {reasons.map((reason, index) => {
            const IconComponent = reason.icon;
            return (
              <div
                key={index}
                className="reason-card"
                style={{ animationDelay: `${index * 0.15}s` }}
              >
                <div className="reason-icon-bg">
                  <IconComponent size={28} className="reason-icon" />
                </div>
                <h3 className="reason-title">{reason.title}</h3>
                <p className="reason-description">{reason.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
